<template>
  <div class="form-group">
   <input type="text" class="form-control" v-model="lookupValue"
    @blur = "blur()"
    @input = "search()"
    @keydown.enter = 'enter'
    @keydown.down = 'down'
    @keydown.up = 'up'
    @keydown.esc = 'esc'
    :disabled='lockEntry'/>
    <div class="panel-footer" v-if="open" @click = "click()">
      <ul class="ui-autocomplete ui-menu" @click = "click()">
        <li v-if="isBasicLookup" class="list-group-item" v-bind:class="{'active': isActive(index)}" v-for="(row, index) in list" @mouseover="MouseOver(index)" @click = "click()" v-bind:key="index">
          <span>{{row.code}}</span>
        </li>
        <li v-if="!isBasicLookup" class="list-group-item" v-bind:class="{'active': isActive(index)}" v-for="(row, index) in list" @mouseover="MouseOver(index)" @click = "click()" v-bind:key="index">
          <span >{{row.name}}<br/><small>{{row.code }}</small></span>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import axios from "axios"
import { authHeader } from '../global';

export default {
  mounted: function()
  {
    if (this.lookupId !== null && this.lookupId != '')
    {
      var newVal = this.lookupId

      axios.post(this.url, {value: newVal, get:1, v2: this.v2}, authHeader())
      .then(response =>
      {
        this.open = false

        if (response.data != null)
        {
          this.list = response.data.data
          this.item = this.list[0]
          if (this.item !== undefined)
          {
            this.lookupValue = this.item.name
            this.selectedId = this.item.id
            this.$emit('selected', this.item)
          }
          this.open = false
        }
      })
    }

    ////console.log("mounted")
    this.lockEntry = this.disabled
    this.isBasicLookup = this.basic
  },
  props:
    ['url','lookupId', 'v2', 'selected', 'disabled', 'basic']
  ,
  watch:
  {
    disabled: function(newVal, oldVal)
    {
      this.lockEntry = newVal
    },
    lookupId: function(newVal, oldVal)
    {
      //console.log("watch start")
      //////console.log(oldVal +" to " + newVal)
      //alert("lookupId")
      if (newVal == null || newVal == "")
      {
        //alert("set to null")
        this.lookupValue = ""
        this.selectedId = null
        this.item = null
        this.list = []
        this.current = -1
        this.$emit('blur', this.item)
      }
      else
      {
        if (newVal != '')
        {
          axios.post(this.url,  {value: newVal, get:1, v2:this.v2}, authHeader())
          .then(response =>
          {
            this.isFirstLoad = false
            this.open = false

            this.list = response.data.data
            if (this.list.length>0)
            {
              this.item = this.list[0]
              if (this.item !== null)
              {
                this.selectedId = this.item.id
                this.lookupValue = this.item.name
                this.$emit('selected', this.item)
              }
            }
            this.open = false
          })
        }
        else
        {
          this.item.id = ""
          this.item.name = ""
          this.selectedId = this.item.id
          this.lookupValue = this.item.name
          ////console.log("emit")
          this.$emit('selected', this.item)
        }
      }
      //console.log("watch end")
    }

  },
  data () {
    return {
      lookupValue: '',
      isBasicLookup: false,
      list: [],
      open: true,
      selectedId: '',
      item: {},
      current: -1,
      lockEntry: false,
      isFirstLoad: true
    }
  },
  methods:{
    clear: function(val)
    {
        this.lookupValue = ""
        this.selectedId = null
        this.item = {id:"", name: ""}
        this.list = []
        this.current = -1
    },
    search(forceSearch = false) {
      this.list = []
      if (this.lookupValue != '' || forceSearch)
      {
        this.open = true
        this.current = -1
        this.selectedId = ''
        axios.post(this.url, {value: this.lookupValue, v2: this.v2}, authHeader()).then(response => {
          //console.log(response)
          this.list = []
          this.list = response.data.data
          if (this.list.length == 0)
          {
            this.current=-1
            this.selectedId = ""
            this.lookupValue = ""
            this.item = {id:"", name: ""}
            this.$emit('selected', this.item)
          }
          else
          {
            this.current=0
            this.item = this.list[this.current]
            this.open = true
          }
        })
      }
      else
      {
          this.current=-1
          this.selectedId = ""
          this.item = {id:"", name: ""}
          this.$emit('selected', this.item)
      }
      //////console.log("search end")
    },
    blur()
    {
      var wasOpen = this.open
      //console.log("blur start")
      this.open = false


      if (this.item !== null)
      {
        if (this.item.id == this.selectedId && this.item.name == this.lookupvalue)
        {
          //console.log("all same")
        }
        else if (this.lookupValue == '' && !wasOpen)
        {
          //console.log("a")
          this.selectedId = ""
          this.lookupValue = ""
          this.item = {id:"", name:""}
          this.$emit('selected', this.item)
        }
        else if (this.lookupValue == '' && wasOpen)
        {
          //console.log("b")
          this.item = this.list[this.current]
          if (this.item !== undefined)
          {
            this.selectedId = this.item.id
            this.lookupValue = this.item.name
          }
          else
          {
            this.item = {id:"", name: ""}
            this.selectedId = this.item.id
            this.lookupValue = this.item.name

          }
          this.$emit('selected', this.item)
        }
        else if (this.current >= 0 && this.list.length > 0 && this.selectedId == "")
        {
          //console.log("c")
          //console.log(this.list)
          //console.log("this.current = " + this.current)
          this.item = this.list[this.current]

          if (this.item !== undefined)
          {
            if (this.item.id !== undefined)
            {
              this.selectedId = this.item.id
              this.lookupValue = this.item.name
            }
          }

          this.$emit('selected', this.item)
        }
        else if (this.item.id == "" && this.lookupValue != '')
       {
          //////console.log("c")
          this.selectedId = ""
          this.lookupValue = ""
          this.item.id = this.selectedId
          this.item.name = this.lookupValue

          this.$emit('selected', this.item)
        }
        else if (this.item.id != this.selectedId || this.item.name != this.lookupValue)
        {

          this.current = -1
          this.selectedId=""
          this.lookupValue=""
          this.item.id = this.selectedId
          this.item.name = this.lookupValue

          this.$emit('selected', this.item)
        }
      }
      else
      {
        this.lookupValue = ""
      }
      //console.log("blur end")

      this.$emit('blur', this.item)
    },
    click()
    {
      if (this.current < this.list.length-1)
      {
        this.item = this.list[this.current]
        this.$emit('selected', this.item)
      }
    },
    MouseOver(index)
    {
      this.current = index
    },
    esc()
    {
      this.open = false
    },
    enter () {
      //////console.log("enter start")
      if (this.list.length)
      {
        if (this.current >= 0)
        {
          this.item = this.list[this.current]
          this.selectedId = this.item.id
          this.lookupValue = this.item.name
          this.$emit('selected', this.item)
        }
        this.open = false
      }
      //////console.log("enter end")
    },
    up () {
      if (this.current > 0 && this.open) {
        this.current--
      }
    },
    down () {
      ////console.log("lookup : '" + this.lookupValue + "'")
      ////console.log("condition: " + this.open)
      if (this.lookupValue == '' && !this.open)
      {
        this.search(true)
        this.current=0
      }
      else if (this.current < this.list.length - 1 && this.open) {
        this.current++
      }
      else
      {
        this.search(true)
        this.current=0
      }
    },
    isActive (index) {
      return index === this.current
    },
  }
}
</script>
<style>
        .ui-menu
        {
            float: left;
            list-style: none outside none;
            margin: 0;
            padding: 2px;
            background-color: aliceblue;
        }
        .ui-autocomplete
        {
            cursor: default;
            position: absolute;
            z-index: 9999
        }
        .ui-menu .ui-menu-item
        {
            clear: left;
            float: left;
            margin: 0;
            padding: 0;
            width: 100%;
        }
        .ui-menu .ui-menu-item a
        {
            display: block;
            padding: 3px 3px 3px 3px;
            text-decoration: none;
            cursor: pointer;
            background-color: Green;
        }
        .ui-menu .ui-menu-item a:hover
        {
            display: block;
            padding: 3px 3px 3px 3px;
            text-decoration: none;
            color: White;
            cursor: pointer;
            background-color: ButtonText;
        }
</style>
